import { z } from "zod";

// API-boundary contract for the PowerSync token endpoint. Plain zod (no drizzle
// / pg-core) so the mobile bundle stays decoupled from the DB package. Both the
// API route handler and the mobile api/ client import this, so the response
// shape can't drift.

export const PowerSyncTokenResponseSchema = z.object({
  expiresAt: z.number(),
  powersyncUrl: z.string(),
  token: z.string(),
});
export type PowerSyncTokenResponse = z.infer<
  typeof PowerSyncTokenResponseSchema
>;

// One entry in the upload endpoint's `completed` array: the ack for a single
// CRUD op. An `error` present means the server rejected the op, so the client
// drops it and surfaces the discard. Shared so the API producer and the mobile
// consumer can't drift on the ack shape.
const PowerSyncUploadResultSchema = z.object({
  error: z.string().optional(),
  opId: z.string(),
});
export type PowerSyncUploadResult = z.infer<typeof PowerSyncUploadResultSchema>;

// The `opId` join key between an uploaded CRUD op and its ack. The API builds it
// when producing `completed`; the client rebuilds it to match an ack back to the
// op it discarded. Shared so the format is defined once on both sides.
export function formatUploadOpId(op: {
  op: string;
  type: string;
  id: string;
}): string {
  return `${op.op}:${op.type}:${op.id}`;
}
